import { useHashLocation } from "wouter-preact/use-hash-location";

export const useLocation = useHashLocation;
